var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "data-testid": "statistics-page"
    }
  }, [_c('div', {
    staticClass: "row justify-content-center p-1"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "title": "Předchozí měsíc",
      "data-testid": "statistics-previous-month"
    },
    on: {
      "click": function($event) {
        _vm.previousMonth()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "MMMM yyyy",
      "language": "cs",
      "disabled": _vm.disableFutureDates,
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datePickerBorderLessInput",
      "minimumView": 'month',
      "maximumView": 'year',
      "initialView": 'month'
    },
    on: {
      "input": function($event) {
        _vm.loadMonthStatistics()
      }
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), (_vm.$moment(_vm.selectedDate).format('YYYYMM') < _vm.$moment().format('YYYYMM')) ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "title": "Následující měsíc",
      "data-testid": "statistics-next-month"
    },
    on: {
      "click": function($event) {
        _vm.nextMonth()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]) : _c('button', {
    staticClass: "btn btn-sm btn-primary disabled",
    attrs: {
      "type": "button",
      "title": "Následující měsíc",
      "disabled": "disabled",
      "data-testid": "statistics-next-month"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(_vm.monthStatistics) ? _c('insurance-month-bar-chart', {
    attrs: {
      "labels": _vm.monthStatistics.labels,
      "reload": _vm.monthStatisticsDone,
      "datasets": _vm.monthStatistics.per_company
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.monthStatistics) ? _c('table', {
    staticClass: "table table-hover",
    attrs: {
      "data-testid": "statistics-insurance-table"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.monthStatistics.per_company), function(company) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(company.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(company.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(company.visit_counts))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(company.total / company.visit_counts)))])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.monthStatistics.total.total))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.monthStatistics.total.visit_counts))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(Math.round(_vm.monthStatistics.total.total / _vm.monthStatistics.total.visit_counts)))])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.monthStatistics) ? _c('table', {
    staticClass: "table table-hover",
    attrs: {
      "data-testid": "statistics-doctor-table"
    }
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.monthStatistics.per_doctors), function(doctor) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(doctor.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(doctor.total))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(doctor.visit_counts))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(doctor.total / doctor.visit_counts)))])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.monthStatistics.total.total))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.monthStatistics.total.visit_counts))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(Math.round(_vm.monthStatistics.total.total / _vm.monthStatistics.total.visit_counts)))])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [(_vm.monthStatistics) ? _c('table', {
    staticClass: "table table-hover",
    attrs: {
      "data-testid": "statistics-operation-table"
    }
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.monthStatistics.per_operations), function(operation) {
    return _c('tr', [_c('td', {
      attrs: {
        "title": operation.title
      }
    }, [_vm._v(_vm._s(operation.label))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operation.points))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(operation.count))])])
  }))]) : _vm._e()])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("pojišťovny")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("pojišťovna")]), _vm._v(" "), _c('th', [_vm._v("body")]), _vm._v(" "), _c('th', [_vm._v("počet návštěv")]), _vm._v(" "), _c('th', [_vm._v("průměrná výtěžnost b/n")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("celkem")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("doktoři")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("doktor")]), _vm._v(" "), _c('th', [_vm._v("body")]), _vm._v(" "), _c('th', [_vm._v("počet návštěv")]), _vm._v(" "), _c('th', [_vm._v("průměrná výtěžnost b/n")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("celkem")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h5', [_vm._v("výkony")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("výkon")]), _vm._v(" "), _c('th', [_vm._v("body")]), _vm._v(" "), _c('th', [_vm._v("počet")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02177ef3","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Statistic/components/Statistic.vue
// module id = 724
// module chunks = 0